module.exports = __webpack_public_path__ + "static/media/cdjr.b98705c6.gif";